import type { FinanceOptions } from "@ir/types";

/**
 * Granite's customer premium is the portal base premium. Older stored quotes
 * used the finance full-payment figure as `annually`, so prefer the nested
 * breakdown when it is available and fall back for legacy records.
 */
export function getGraniteAnnualPremium(options?: FinanceOptions | null): number {
  if (!options) return 0;

  const basePremium =
    options.elevenMonths?.breakdown?.basePremiumTotal ??
    options.tenMonths?.breakdown?.basePremiumTotal ??
    0;

  return basePremium > 0 ? basePremium : options.annually ?? 0;
}

export function getProviderAnnualPremium(
  provider: string | null | undefined,
  options?: FinanceOptions | null,
): number {
  return provider?.trim().toLowerCase() === "granite"
    ? getGraniteAnnualPremium(options)
    : options?.annually ?? 0;
}
